module.exports = __webpack_public_path__ + "static/media/map-marker.22468c1a.svg";